import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import { hasWebGL } from '../lib/webgl';
import useReducedMotion from '../hooks/useReducedMotion';

const GravityField = lazy(() => import('../three/GravityField'));

function StaticFallback() {
  return (
    <div
      data-testid="hero-fallback"
      className="absolute inset-0 bg-ink-900"
      style={{
        backgroundImage:
          'radial-gradient(120% 90% at 50% 35%, rgba(233,210,23,0.07), rgba(0,0,0,0) 55%), ' +
          'repeating-linear-gradient(0deg, rgba(255,255,255,0.05) 0 1px, transparent 1px 42px), ' +
          'repeating-linear-gradient(90deg, rgba(255,255,255,0.05) 0 1px, transparent 1px 42px)',
      }}
    />
  );
}

export default function HeroBackground() {
  const reduced = useReducedMotion();
  const [supported] = useState(() => hasWebGL());
  const [active, setActive] = useState(true);
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const io = new IntersectionObserver(([e]) => setActive(e.isIntersecting), { threshold: 0.05 });
    io.observe(node);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className="absolute inset-0 z-0">
      {supported && !reduced ? (
        <Suspense fallback={<StaticFallback />}>
          <GravityField active={active} />
        </Suspense>
      ) : (
        <StaticFallback />
      )}
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(120% 95% at 50% 30%, rgba(0,0,0,0) 38%, rgba(0,0,0,0.88) 100%)' }} />
    </div>
  );
}
